import { Component, input } from '@angular/core';
import { MobilePhoneProduct } from '@app/sales/models/mobilephone-product';
import { PriceFormatPipe, PriceType } from '@app/shared/pipes/price-format.pipe';

@Component({
  selector: 'app-phone-card',
  imports: [PriceFormatPipe],
  templateUrl: './phone-card.component.html',
  styleUrl: './phone-card.component.scss',
})
export class PhoneCardComponent {
  PriceType = PriceType;

  phone = input.required<MobilePhoneProduct>();
  title = input<string>('Telefon');
}
